import { actions } from "../../../../../common/constants";

const initialState = {
  isPostItemsLoaded: false,
  isSubmitting: false,
  post_items: {},

  isPostItemLoaded: false,
  post_item: {},

  isPostsByTripLoaded: false,
  posts_by_trip: {},
};

const actionMap = {
  [actions.GET_POST_ITEMS_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isPostItemsLoaded: false,
  }),
  [actions.GET_POST_ITEMS_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isPostItemsLoaded: true,
    post_items: result.data,
  }),
  [actions.GET_POST_ITEMS_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isPostItemsLoaded: false,
  }),

  [actions.GET_POST_ITEM_DETAIL_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isPostItemLoaded: false,
  }),
  [actions.GET_POST_ITEM_DETAIL_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isPostItemLoaded: true,
    post_item: result.data,
  }),
  [actions.GET_POST_ITEM_DETAIL_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isPostItemLoaded: false,
  }),

  [actions.GET_POSTS_ITEM_BY_TRIP_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isPostsByTripLoaded: false,
  }),
  [actions.GET_POSTS_ITEM_BY_TRIP_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isPostsByTripLoaded: true,
    posts_by_trip: result.data,
  }),
  [actions.GET_POSTS_ITEM_BY_TRIP_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isPostsByTripLoaded: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};



// WEBPACK FOOTER //
// ./client/react/Admin/store/reducers/posts.js